import { render } from "./MsAddPropertyModal.vue?vue&type=template&id=846a7a72&ts=true"
import script from "./MsAddPropertyModal.vue?vue&type=script&lang=ts"
export * from "./MsAddPropertyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__